// ContentContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { db, storage } from '../firebase';
import { doc, setDoc, getDoc, collection, addDoc, getDocs } from 'firebase/firestore';

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
 // ContentContext.jsx
const [publishedContent, setPublishedContent] = useState({
    title: "AGRITECH 101: HOW A SMART SCHOOL GARDEN IS GROWING MORE THAN JUST FOOD!",
    description: "From food security to leadership – discover how one garden became a classroom, a community hub, and a catalyst for change",
    body: "How a School Garden Became a Hub for Learning, Leadership, and Community...", // truncated for brevity
    image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1757189481/banner_images/Register_as_a_farmer_1_p3nqem.jpg",
    video: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1757189481/banner_images/Register_as_a_farmer_1_p3nqem.jpg",
    metadata: "Story by Farmnet • 3h • 2 min read",
  });
  
  const [savedContents, setSavedContents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Load content from Firebase on initial render
  useEffect(() => {
    const loadContent = async () => {
      try {
        setIsLoading(true);
        
        // Load published content
        const docRef = doc(db, "content", "topBanner");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setPublishedContent(docSnap.data());
        }
        
        // Load saved contents
        const querySnapshot = await getDocs(collection(db, "savedContents"));
        const contents = [];
        querySnapshot.forEach((doc) => {
          contents.push(doc.data());
        });
        setSavedContents(contents);
        
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading content from Firebase:", error);
        setIsLoading(false);
      }
    };
    loadContent();
  }, []);

  // Function to save content to Firebase (for published content)
  const saveContentToFirebase = async (content) => {
    try {
      await setDoc(doc(db, "content", "topBanner"), content);
      console.log("Content saved to Firebase");
    } catch (error) {
      console.error("Error saving content to Firebase:", error);
      throw error;
    }
  };

  // Function to save a new version to saved contents
  const saveContentVersion = async (content) => {
    try {
      const docRef = await addDoc(collection(db, "savedContents"), {
        ...content,
        createdAt: new Date().toISOString()
      });
      setSavedContents(prev => [...prev, { ...content, id: docRef.id }]);
      console.log("Content version saved to Firebase");
    } catch (error) {
      console.error("Error saving content version:", error);
      throw error;
    }
  };

  return (
    <ContentContext.Provider value={{ 
      publishedContent, 
      setPublishedContent, 
      saveContentToFirebase, 
      savedContents,
      saveContentVersion,
      isLoading 
    }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);